import Animations from '../styles/animations.css'
import Fonts from '../styles/fonts.css'
import Scrollbar from '../styles/scrollbar.css'
import Styles from '../styles/styles.css'
import Themes from '../styles/theme.css'

export default {
  Animations, Fonts, Scrollbar, Styles, Themes
}
